import GlobalTemplate from './GlobalTemplate';
export default GlobalTemplate;